import { Contacts, ContactsProps } from "./Contacts"
import { FooterLink, FooterLinks } from "./FooterLinks"

import cssModule from "./index.module.scss"

export type { FooterLink } from "./FooterLinks"
export type { ContactsProps } from "./Contacts"

export function FooterContent({
	links,
	contacts,
}: {
	links?: FooterLink[]
	contacts?: ContactsProps
}) {
	return (
		<div className={cssModule.footerContent}>
			{links && <FooterLinks links={links} />}
			<div style={{ flex: "1 0 auto"}}></div>
			{contacts && (
				<Contacts
					phone={contacts.phone}
					/*localPhone={contacts.localPhone}*/ email={contacts.email}
				/>
			)}
		</div>
	)
}
